import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class AppService implements OnDestroy {

  // Used to block parent containter scrolling when child view (sliding above parent view) is visible. Like this only th child view is scrollable when active.
  private blockScrolling = new BehaviorSubject<boolean>(false);
  public blockScrolling$ = this.blockScrolling.asObservable();


  // Used to show the main spinner loading icon in the middle of the main view.
  private isLoading = new BehaviorSubject<boolean>(false);
  public isLoading$ = this.isLoading.asObservable();
  // public isLoadingDelayed$ = this.isLoading.asObservable().pipe(delay(275)); // Used to display the loading icon, only after page transition is done (th backdrop panel is using isLoading$)


  // Used to bind the menu items on the left panel of the web app.
  private leftMenuItems = new BehaviorSubject<any[]>([]);
  public leftMenuItems$ = this.leftMenuItems.asObservable();


  // Used on the left menu to show a spinner loading icon instead of the menu item icon when lasy-loading a route.
  private lasyLoadingRoutePath = new BehaviorSubject<string>(null);
  public lasyLoadingRoutePath$ = this.lasyLoadingRoutePath.asObservable();


  // Used to let nested views inform the main view (usually the Grid View) to refresh after some events (like 'entity added/updated/inserted) etc.
  private refreshMainViewYN = new BehaviorSubject<boolean>(false);
  public refreshMainViewYN$ = this.refreshMainViewYN.asObservable();


  // Used to let double nested views (2 drawers) inform the first nested view (one drawer) to refresh after some events (like 'sub entity added/updated/inserted) etc.
  private refreshNestedViewYN = new BehaviorSubject<boolean>(false);
  public refreshNestedViewYN$ = this.refreshNestedViewYN.asObservable();


    // Used as a "catch all" for communication between components with a service
    private customData = new BehaviorSubject<any>(null);
    public customData$ = this.customData.asObservable();





  constructor() {}

  setBlockScrolling(blockYN: boolean) {
    this.blockScrolling.next(blockYN);
  }

  //   getBlockScrolling(): Observable<boolean> {
  //     return this.blockScrolling$;
  //   }


  setIsLoading(isLoadingYN: boolean) {
    this.isLoading.next(isLoadingYN);
  }


  setLeftMenuItems(menuItems: any[]) {
    this.leftMenuItems.next(menuItems);
  }


  setLasyLoadingRoutePath(routePath: string) {
    this.lasyLoadingRoutePath.next(routePath);
  }


  setRefreshMainViewYN(refreshYN: boolean) {
    this.refreshMainViewYN.next(refreshYN);
  }



  setRefreshNestedViewYN(refreshYN: boolean) {
    this.refreshNestedViewYN.next(refreshYN);
  }


  setCustomData(customData: any) {
    this.customData.next(customData);
  }





  ngOnDestroy() {
    // Unsubscribe when the component is destroyed
    this.blockScrolling.complete();
    this.isLoading.complete();
    this.leftMenuItems.complete();
    this.lasyLoadingRoutePath.complete();
    this.refreshMainViewYN.complete();
    this.refreshNestedViewYN.complete();
    this.customData.complete();
  }

}
